import React from "react";
import StyledSwitch from "./Switch.styles";

const Switch: React.FC = ({ ...props }) => {
  return (
      <StyledSwitch {...props} />
  );
};

export default Switch;
